import React from 'react';
import intl from 'react-intl-universal';
import { connect } from 'react-redux';
import {
  getUserRolesSelector,
  getUserInfoSelector,
  isEYProSelector,
  isApplicantSelector,
  isCorpClientSelector,
  isCorporateClientLineManagerSelector,
  isRestrictedCorpMemberSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { CASE_DETAIL_URL } from 'src/constants/constants';
import { createRowMap, createTableColumns } from 'src/helpers';
import { TableLanding } from 'src/ui/library/Table/extensions';
import { getCaseFiltersAPI, fetchCases, getAppTypesByCountry } from 'src/services/cases.service';
import { fetchSLAStatus } from 'src/services/dashboard.service';
import Button from 'src/ui/library/Button';
import { formatDate } from 'src/helpers/date';
import { setTaskType } from '../../../features/Dashboard/state/dashboardActions';
import { DATA_TYPE } from '../../../../constants/constants';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

class CasesTableContainer extends React.Component {
  static defaultProps = {
    hideLandingHeader: false,
    defaultFilterValues: {
      caseStatusType: 'All',
      /* this value gets populated when <CasesTableContainer /> is used from EmployeeCasesPres */
      employeeId: undefined,
      /* this value gets populated when <CasesTableContainer /> is used from DocumentsDetailPres */
      documentId: undefined,
      caseSLAStatus: [],
    },
  };

  componentDidMount() {
    fetchSLAStatus().then(res => {
      if (res && !res.error && !res.errors) {
        this.setState({
          caseSLAStatus: res,
        });
      }
    });
  }

  getCaseId(data) {
    const {
      model: { columns, rows },
      rowClicked: { origRowIndex },
    } = data;

    const { caseId } = createRowMap(columns, rows[origRowIndex]);
    return caseId;
  }

  getTableColumns = () => {
    const { isCorpClient, isEYPro, isCorpClientLineManager, isApplicant } = this.props;

    const columnsName = [
      'assignmentenddate',
      'assignmentstartdate',
      'caseManagerId',
      'applicant',
      'ticketNumber',
      'caseId',
      'eyService',
      'caseType',
      'serviceCountry',
      'targetDate',
      'daysOld',
      'createdOn',
      'casePhase',
      'modifiedOn',
      'client',
      'entity',
      'pathway',
      'messages',
      'dependentName',
    ];

    const columns = createTableColumns('cases', {
      columns: columnsName,
      visible: [
        isCorpClient || isCorpClientLineManager ? 'applicant' : null,
        'ticketNumber',
        'eyService',
        isCorpClient || isCorpClientLineManager ? 'employeeId' : null,
        'targetDate',
        isEYPro ? 'client' : null,
        'openCaseStatus',
        'casePhase',
        // 'caseType', hide until further instructions
        'serviceCountry',
        isApplicant ? 'dependentName' : null,
      ],
      options: {
        applicant: {
          sortable: false,
        },
        client: {
          sortable: false,
        },
        employeeId: {
          sortable: false,
        },
        messages: {
          sortable: false,
        },
        targetDate: {
          renderComponent: (value, options) => {
            // revisit this. overly complex
            // let dayOld = oldDays[options.origRowIndex];
            // let dayOldText = dayOld === '-' ? 'Closed' : dayOld > 1 ? ' days old' : ' day old';
            // let days = dayOld === '-' ? '' : dayOld;

            return formatDate(value);
          },
        },
        dependentName: {
          renderComponent: (value, options) => {
            return value || '-';
          },
        },
      },
    });

    return columns;
  };

  getFastFilters = response => {
    const { defaultFilterValues } = this.props;
    const { counts } = response;
    const { caseSLAStatus = [] } = this.state || {};

    const isAllSelected = defaultFilterValues.caseStatusType === 'all';
    const isOpenSelected = defaultFilterValues.caseStatusType === 'open';
    const isClosedSelected = defaultFilterValues.caseStatusType === 'closed';
    const isCancelledSelected = defaultFilterValues.caseStatusType === 'cancelled';
    let slaStatusFastFilters = [];

    caseSLAStatus.forEach(status => {
      slaStatusFastFilters.push({
        id: status.id,
        label: status.name,
        value: counts[status.id],
        selected: defaultFilterValues.slaStatus === status.id,
      });
    });

    const defaultFastFilters = [
      { id: 'all', label: 'All', value: counts.allCaseCount, selected: isAllSelected, defaultSelected: true },
      { id: 'open', label: 'Open', value: counts.openCaseCount, selected: isOpenSelected },
      { id: 'closed', label: 'Closed', value: counts.closedCaseCount, selected: isClosedSelected },
      { id: 'cancelled', label: 'Cancelled', value: counts.cancelledCaseCount, selected: isCancelledSelected },

      // business may bring these filters back in the future
      // { id: 'compensation', label: 'Compensation', value: response.compensationCaseCount },
      // { id: 'immigration', label: 'Immigration', value: response.immigrationCaseCount },
      // { id: 'Tax', label: 'Immigration', value: response.taxCaseCount },
    ];

    const fastFilters = [...defaultFastFilters, ...slaStatusFastFilters];

    return fastFilters;
  };

  getDropDownFilters = response => {
    const { history, isApplicant, isRestrictedCorpUser } = this.props;
    const hash = history.location.hash;
    let fastFilters = [{ id: 'myCase', label: DATA_TYPE.MY_DATA, value: 0, selected: hash ? hash.includes('myCase') : true }];

    if (isApplicant || isRestrictedCorpUser) {
      return fastFilters;
    }

    fastFilters = [
      ...fastFilters,
      { id: 'teamCase', label: DATA_TYPE.ALL_DATA, value: 0, selected: hash ? hash.includes('teamCase') : false },
    ];

    return fastFilters;
  };

  getGridFilters = response => {
    const { policies, services, countries, applicationTypes } = response.filters;

    const config = [
      {
        id: 'policy',
        controlType: 'Dropdown',
        label: intl.get('cases.filters.labels.policy'),
        options: policies ? policies.map(item => ({ value: item.id, label: item.name })) : [],
      },
      {
        id: 'service',
        controlType: 'Dropdown',
        label: intl.get('cases.filters.labels.service'),
        options: services ? services.map(item => ({ value: item.id, label: item.name })) : [],
      },
      // Hide until further instructions
      // {
      //   id: 'caseType',
      //   controlType: 'Dropdown',
      //   label: intl.get('cases.filters.labels.caseType'),
      //   options: caseTypes ? caseTypes.map(item => ({ value: item.id, label: item.name })) : [],
      // },
      { id: 'createdDate', controlType: 'Date', label: intl.get('cases.filters.labels.createdDate') },
      { id: 'targetDateStart', controlType: 'Date', label: intl.get('cases.filters.labels.from') },
      { id: 'targetDateEnd', controlType: 'Date', label: intl.get('cases.filters.labels.to') },
      {
        id: 'homeCountry',
        controlType: 'Dropdown',
        label: intl.get('cases.filters.labels.homeCountry'),
        options: countries ? countries.map(item => ({ value: item.id, label: item.name })) : [],
      },
      {
        id: 'hostCountry',
        controlType: 'Dropdown',
        label: intl.get('cases.filters.labels.hostCountry'),
        options: countries ? countries.map(item => ({ value: item.id, label: item.name })) : [],
      },
      {
        id: 'applicationType',
        controlType: 'Dropdown',
        label: intl.get('cases.filters.labels.applicationType'),
        options: applicationTypes ? applicationTypes.map(item => ({ value: item.ey_applicationtypeid, label: item.ey_name })) : [],
      },
    ];

    return config;
  };

  onTableChange = (actionType, data, { setTableState, fetchData }) => {
    let caseId;

    switch (actionType) {
      case 'viewDetail':
        caseId = this.getCaseId(data);
        if (fnShowNewDashboard()) {
          window.location.href = CASE_DETAIL_URL + '/' + caseId;
        } else {
          this.props.history.push(`${CASE_DETAIL_URL}/${caseId}`);
        }
        break;

      case 'rowClick':
        caseId = this.getCaseId(data);
        if (fnShowNewDashboard()) {
          window.location.href = CASE_DETAIL_URL + '/' + caseId;
        } else {
          this.props.history.push(`${CASE_DETAIL_URL}/${caseId}`);
        }
        break;

      case 'fastFilter':
        const { all, open, closed, cancelled } = data;
        const { caseSLAStatus } = this.state;
        let newFilters = {};

        if (all) {
          newFilters = {
            caseStatusType: undefined,
            slaStatus: undefined,
          };
        } else if (open) {
          newFilters = {
            caseStatusType: 'open',
            slaStatus: undefined,
          };
        } else if (closed) {
          newFilters = {
            caseStatusType: 'closed',
            slaStatus: undefined,
          };
        } else if (cancelled) {
          newFilters = {
            caseStatusType: 'cancelled',
            slaStatus: undefined,
          };
        } else {
          caseSLAStatus.forEach(status => {
            if (data[status.id]) {
              newFilters = {
                caseStatusType: 'open',
                slaStatus: status.id,
              };
            }
          });
        }

        setTableState({ filters: newFilters }, () => fetchData());

        break;

      default:
        return undefined;
    }
  };

  render() {
    const { isDocument, isApplicant, isRestrictedCorpUser, addCaseAction } = this.props;

    return (
      <TableLanding
        hideLandingHeader={this.props.hideLandingHeader}
        history={this.props.history}
        columns={this.getTableColumns()}
        sortDirection={'desc'}
        sortColumn={'targetDate'}
        actionable={true}
        defaultFilterValues={this.props.defaultFilterValues}
        dropDownFilter={
          isApplicant || isRestrictedCorpUser
            ? null
            : {
                filters: response => this.getDropDownFilters(response),
              }
        }
        fastFilter={{
          filters: response => this.getFastFilters(response),
        }}
        gridFilter={{
          filters: response => this.getGridFilters(response),
          render: TableFilter => (
            <div className="landing-gridfilter-container cases-search">
              {TableFilter}
              {isDocument && (
                <Button styleType="primary" onClick={addCaseAction}>
                  <span>{intl.get('cases.documentCases.addButton')}</span>
                </Button>
              )}
            </div>
          ),
        }}
        taskType={this.props.teamCases ? DATA_TYPE.ALL_DATA : DATA_TYPE.MY_DATA}
        setDashboardType={this.props.setTaskType}
        onRequestData={fetchCases}
        onRequestFilters={getCaseFiltersAPI}
        onTableChange={this.onTableChange}
        onChange={getAppTypesByCountry}
        caption={intl.get('employees.cases.caption')}
      />
    );
  }
}

const mapStateToProps = state => ({
  userInfo: getUserInfoSelector(state),
  userRoles: getUserRolesSelector(state),
  isEYPro: isEYProSelector(state),
  isApplicant: isApplicantSelector(state),
  isCorpClient: isCorpClientSelector(state),
  isCorpClientLineManager: isCorporateClientLineManagerSelector(state),
  isRestrictedCorpUser: isRestrictedCorpMemberSelector(state),
});

const mapDispatchToProps = {
  setTaskType,
};

export default connect(mapStateToProps, mapDispatchToProps)(CasesTableContainer);
